
import { Vue, Component, VModel } from 'vue-property-decorator'

import { observationIcons, dueStatusColor } from '@/types/observation'

@Component({
    inheritAttrs: false,
})
export default class DueStatusFilter extends Vue {
    @VModel() dueStatus!: Array<string>

    dueStatusColor = dueStatusColor
    icon = observationIcons.dueStatus

    remove(item) {
        if (this.lodash.isArray(this.dueStatus)) {
            this.dueStatus.splice(this.dueStatus.indexOf(item), 1)
        }
    }
}
